import { Injectable, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';
import { PRODUCT_NAME } from '../i18n/de';

/**
 * Formats a resolved route title for the browser tab: a bare label ("Ausschreibungen") becomes
 * "Ausschreibungen | Vergabe-Suche"; a missing title falls back to the product name alone. A title that
 * already names the product (the landing page's own tagline, e.g. "Vergabe-Suche – Ausschreibungen
 * verstehen, bevor Sie bieten") is used exactly as given — never double-suffixed. Pure and exported on its
 * own so the formatting rule is testable without faking a Router `RouterStateSnapshot`.
 */
export function formatTitle(label: string | undefined | null): string {
  if (!label) return PRODUCT_NAME;
  return label.includes(PRODUCT_NAME) ? label : `${label} | ${PRODUCT_NAME}`;
}

/**
 * Replaces hardcoding "· Vergabe-Suche" (formerly "· TenderCheck") on every route's own `title` — each
 * route keeps a short, bare label (`worker`-free, purely a routing concern), and this appends the product
 * name centrally. `buildTitle()` is Angular's own route-title resolution (inherited from `TitleStrategy`,
 * unchanged); only what happens with its result is customized here.
 */
@Injectable({ providedIn: 'root' })
export class AppTitleStrategy extends TitleStrategy {
  private readonly title = inject(Title);

  override updateTitle(snapshot: RouterStateSnapshot): void {
    this.title.setTitle(formatTitle(this.buildTitle(snapshot)));
  }
}
